import { FormControlLabel, Switch, SwitchProps } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import React from "react";
import { useFieldValueAndValidation } from "ui/componentes/Form/functions";

interface SwitchFieldFormikProps {
    label?: string;
}

const SwitchFieldFormik: React.FC<SwitchProps & SwitchFieldFormikProps> = (
    props
) => {
    const { handleBlur, setFieldValue } = useFormikContext<any>();

    const { value } = useFieldValueAndValidation(props.name);

    const FieldComponent = (
        <Field
            onChange={(e, checked) => {
                if (props.name) {
                    setFieldValue(props.name || "", checked);
                }
            }}
            checked={value}
            onBlur={handleBlur}
            component={Switch}
            {...props}
        />
    );

    if (props.label) {
        return (
            <FormControlLabel label={props.label} control={FieldComponent} />
        );
    }

    return FieldComponent;
};

export { SwitchFieldFormik };
